import React, { use, useEffect, useState } from 'react';
import './header-mobile.styles.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faChartLine, faClock, faCommentDots, faFolderTree, faGear, faHandsBubbles, faHome, faInfoCircle, faListCheck, faMountainCity, faUser, faUsers, faX } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarLeftContainer from '../sidebar-left/sidebar-container.component';
import logo_long from '@/assets/logo_long.png';
import icon from '@/assets/icon.png';
import UserIcon from '../user-icon/user-icon.component';
import UserDropdown from './user-dropdown.component';
import BugModal from '../feedback-modal/bug-modal.component';
import FeedbackModal from '../feedback-modal/feedback-modal.component';

// import SidebarLeft from 'components/sidebar-left/sidebar-left.component';

const HeaderMobile = () => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ menuOpen, setMenuOpen ] = useState(false);
    const [ showDropdown, setShowDropdown ] = useState(false);
    const [ showFeedbackModal, setShowFeedbackModal ] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setMenuOpen(false);
    }, [location])

    useEffect(() => {
        if (showFeedbackModal) {
            setMenuOpen(false);
        }
    }, [showFeedbackModal])
    
    function toggleMenu() {
        setMenuOpen(!menuOpen);
    };
    
    return (
        <div className="mobile-header">
            <div className="mobile-header-grid">
                <div className='left-div'>
                    <button className="mobile-header__menu-button" id="slide-menu" onClick={toggleMenu}>
                        <FontAwesomeIcon icon={faBars} />
                    </button>
                    <img src={logo_long} alt='Gamably Logo' className='logo' />
                </div>
                <button 
                    className='g-button text-only icon-button'
                    onClick={() => setShowDropdown(!showDropdown)} >
                    <UserIcon 
                        className='clickable' 
                        profile={userProfile} 
                        reverse={true} 
                        planIcon={true} />
                </button>
            </div>
            <div className={`mobile-header__menu-items ${menuOpen ? "show": ""} ${screenSize}`}>
                <div 
                    className='close-button' 
                    onClick={() => setMenuOpen(!menuOpen)}>
                    <FontAwesomeIcon 
                        icon={faX} 
                        size='xl' />
                </div>
                <SidebarLeftContainer 
                    setShowFeedbackModal={setShowFeedbackModal} />
            </div>

            {/* <div className='mobile-bottom-menu'>
                <FontAwesomeIcon className='event-menu-item menu-assignments' icon={faListCheck} size='xl' onClick={() => navigate('')} />
                <FontAwesomeIcon className='event-menu-item menu-staff' icon={faUser} size='xl' onClick={() => navigate('staff')} />
                <FontAwesomeIcon className='event-menu-item menu-groups' icon={faUsers} size='lg' onClick={() => navigate('groups')} />
                <FontAwesomeIcon className='event-menu-item menu-locations' icon={faMountainCity} size='xl' onClick={() => navigate('locations')} />
                <FontAwesomeIcon className='event-menu-item menu-timeslots' icon={faClock} size='xl' onClick={() => navigate('timeslots')} />
                <FontAwesomeIcon className='event-menu-item menu-categories' icon={faFolderTree} size='xl' onClick={() => navigate('categories')} />
                <FontAwesomeIcon className='event-menu-item menu-information' icon={faInfoCircle} size='xl' onClick={() => navigate('information')} />
            </div> */}
            <UserDropdown 
                show={showDropdown}
                setShowDropdown={setShowDropdown} />
            <FeedbackModal
                show={showFeedbackModal}
                cancel={() => setShowFeedbackModal(false)} />  
        </div>
    );
};

export default HeaderMobile;